import { LOGIN, LOGOUT, CHECK_AUTH, FETCH_CURRENT_USER, UPDATE_CURRENT_USER, AUTH_ERROR } from 'actions/auth';

const initialState = {
	isAuthenticated: false,
	token: null,
	currentUser: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOGIN:
			return action.payload;
		case LOGOUT:
			return initialState;
		case AUTH_ERROR:
			return { ...initialState, ...action.payload };
		case CHECK_AUTH:
			return action.payload;
		case FETCH_CURRENT_USER:
			return { ...state, currentUser: action.payload };
		case UPDATE_CURRENT_USER:
			return { ...state, currentUser: action.payload };
		default:
			return state;
	}
};